import { Component } from '@angular/core';
import { FORMS } from '../forms';
import { SETTINGS as settings } from '../model';
import { OfbizList,OfbizForm } from '@urbannex/ofbiz-forms';
import { BaseComponentConfig, BreadCrumbData, ComponentConfig, ConfigOptions, CustomContainerItem, UpdateComponentStoreService, ViewBlogContainerComponent, ViewContainersService } from '@urbannex/view-containers';
import { ActivatedRoute, Router } from '@angular/router';
import { NbMenuService } from '@nebular/theme';
import { ConfigurationService } from '@urbannex/configuration';

@Component({
  selector: 'ubs-blog',
  template: `<ubs-view-containers [componentConfig]="componentConfig" [breadCrumbs]="breadCrumbs"></ubs-view-containers>`,
  styleUrls: ['./blog.component.scss']
})
export class BlogComponent extends BaseComponentConfig {
  breadCrumbs:BreadCrumbData[];
  options:ConfigOptions = {
    name:"Name",
    title:"Blogs",
    idFieldName:"contentId",
    lookUpEndPoint:"LookupContent",
    searchResults:null,
    listForm:new OfbizList({
      fieldFormName:"FindContent",
      fieldFormLocation:"local",
      fieldFormFields:this.getFields("FindContent",FORMS),
      listFormName:"ListBlogsRest",
      entityName:"Content",
      listFormLocation:"component://content/widget/forum/BlogForms.xml",
      columnFields:this.getFields("ListBlogsRest",FORMS),
      endPoint:"listFindContent",
      emptyListMessage:"No blogs found",
      viewIndex:1,
      actions:{
        position:'right',
        custom:[
          {
            name:'linkedList',
            title:'<i class="nb-folder-outline" title="Linked List"></i>'
          }
        ],
        delete:false,
      },
    }),
    findForm:new OfbizForm({
      local:true,
      viewMode:"popover",
      formAction:"find",
      formName:"FindContent",
      entityName:"Content",
      formLocation:"component://content/widget/content/ContentForms.xml",
      target:"listFindContent",
      fields:this.getFields("FindContent",FORMS),
    }),    
    addForm:new OfbizForm({
      local:true,
      formName:"EditBlogRest",
      entityName:"Content",
      formLocation:"component://content/widget/forum/BlogForms.xml",
      fields:this.getFields("EditBlogRest",FORMS),
      target:this.getTarget("EditBlogRest",FORMS),
      altTargets:this.getAltTarget("EditBlogRest",FORMS),
      targets:this.getTargets("EditBlogRest",FORMS)
    }),
    actions:["list","find","add","edit"],
    breadCrumbData:{
      displayPrefix:"Blogs",
      label:"",
      level:1,
      selectedValue:{
          "event":"list",
          "type":"ListBlogs",
          "data":{
            "formData":{
              "formName":"ListBlogsRest",
              "formLocation":"component://content/widget/forum/BlogForms.xml",
            },
            "endPoint":"listFindContent",
          },
      },
      addFormText:"Create New Blog",
      editFormText:"Update Blog",
    },
    settings:settings,
    childComponent:new ComponentConfig({
      name:"Name",
      title:"Blogs",
      idFieldName:"contentId",
      lookUpEndPoint:"LookupContent",
      searchResults:null,
      listForm:new OfbizList({
        fieldFormName:"FindBlogContent",
        fieldFormLocation:"component://commonforms/widget/CommonFormsForms.xml",
        fieldFormFields:this.getFields("FindBlogContent",FORMS),
        listFormName:"ListBlogContent",
        entityName:"ContentAssocViewTo",
        listFormLocation:"component://commonforms/widget/CommonFormsForms.xml",
        endPoint:"listFindBlogContent",
        viewIndex:1,
        columnFields:this.getFields("ListBlogContent",FORMS),
        emptyListMessage:"Nothing found sorry"
      }),
      findForm:new OfbizForm({
        local:true,
        viewMode:"popover",
        formAction:"find",
        formName:"FindContent",
        entityName:"Content",
        formLocation:"component://content/widget/content/ContentForms.xml",
        target:"listFindContent",
        fields:this.getFields("FindContent",FORMS),
      }),    
      addForm:new OfbizForm({
        local:true,
        formName:"EditArticleRest",
        entityName:"WebSiteContent",
        formLocation:"component://content/widget/website/WebSiteForms.xml",
        fields:this.getFields("EditArticleRest",FORMS),
        renderComponent:"ViewBlogArticle",
        target:this.getTarget("EditArticleRest",FORMS),
        altTargets:this.getAltTarget("EditArticleRest",FORMS)
      }),
      actions:["list","find","add","edit"],
      breadCrumbData:{
        displayPrefix:"Articles for ",
        label:"",
        level:2,
        selectedValue:{
          "event":"list",
          "type":"ListBlogContent",
          "data":{
            formData:{
              "formName":"ListBlogContent",
              "formLocation":"component://commonforms/widget/CommonFormsForms.xml",
            },
            "endPoint":""
          }
        },
        addFormText:"Create New Article",
        editFormText:"Update Article",
      },
      settings:[]
    }),
    customContainerItems:[
      new CustomContainerItem("ViewBlogArticle",ViewBlogContainerComponent,{})
    ]
  }



  constructor(viewContainerService:ViewContainersService,
    menuService:NbMenuService,
    route:ActivatedRoute,
    router:Router,
    updateComponentStoreService:UpdateComponentStoreService,
    configurationService:ConfigurationService) {
    super(viewContainerService,menuService,configurationService,route,router,updateComponentStoreService)
    this.componentConfig = new ComponentConfig(this.options);
    //this.cmsStore.updateComponentConfig(this.componentConfig);
   }

   ngOnInit(): void {
     //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
     //Add 'implements OnInit' to the class.
     this.breadCrumbs = this.setBreadCrumbs(this.componentConfig);
   }

}


